var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "cv_list" },
      [
        _c(
          "swiper",
          { attrs: { options: _vm.swiperOptionsVideoNormal } },
          _vm._l(_vm.videoList[_vm.id % 3], function (item, index) {
            return _c("swiper-slide", { key: index }, [
              _c("div", { staticClass: "cvl_item" }, [
                _c("div", { staticClass: "cvl_img" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "/old-page?id=" + item.id,
                        target: "_blank",
                      },
                    },
                    [_c("img", { attrs: { src: item.src, alt: "" } })]
                  ),
                  _c("div", { staticClass: "time" }, [
                    _vm._v(_vm._s(item.videoDuration)),
                  ]),
                ]),
                _c("div", { staticClass: "cvl_title" }, [
                  _vm._v(_vm._s(item.title)),
                ]),
              ]),
            ])
          }),
          1
        ),
        _c("div", {
          staticClass:
            "swiper-button-next normal-button-next el-icon-arrow-right",
          attrs: { slot: "pagination" },
          slot: "pagination",
        }),
        _c("div", {
          staticClass:
            "swiper-button-prev normal-button-prev el-icon-arrow-left",
          attrs: { slot: "pagination" },
          slot: "pagination",
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }